import { Image, UIText1 } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './PromosBanner.css';
import promoSvg from './assets/promo.svg';

export interface IPromosBannerProps {
  contactsButton: React.ReactElement;
}

export const PromosBanner = ({ contactsButton }: IPromosBannerProps) => {
  return (
    <div className={classNames(styles['banner'])} data-testid="promos-banner">
      <div className={styles['image-wrapper']}>
        <Image src={promoSvg} objectFit="contain" height="80px" display="block" />
      </div>
      <div className={styles['text']}>
        <UIText1>
          Узнайте про персональные условия и дополнительные скидки при&nbsp;покупке квартиры у застройщика
        </UIText1>
      </div>
      <div className={styles['call-button-wrapper']}>{contactsButton}</div>
    </div>
  );
};
